import type { RefObject } from "react";
import { Icone } from "../componentes/Icone.js";
import { IconeIa } from "../componentes/icones.js";

/**
 * O gatilho flutuante do rodapé da tela de execução — RN-42, RN-55, RN-56.
 *
 * **Um alvo, e não dois.** Ele era um menu de dois — o caderno em repouso e o
 * assistente subindo por trás dele — porque o rodapé tinha um canto só para dar
 * a duas superfícies de apoio. Na Fase 2 o caderno saiu daqui e foi para o
 * cabeçalho da questão, junto de marcar, do cronômetro e de "não entendi":
 * escrever sobre o que está na tela é da mesma família que marcar, e a mão
 * procura as três no mesmo lugar. Sem o caderno, o menu de dois vira um alvo só,
 * e o gesto de "primeiro toque expande, segundo aciona" — que existia só para
 * alcançar o segundo alvo — deixa de ter razão.
 *
 * **À direita nas duas larguras.** A regra anterior mandava o botão para a
 * esquerda em tela larga, para afastá-lo de "próximo item". O que ela não pesava
 * é que o painel **abre à direita**: um gatilho no canto oposto ao que ele abre
 * faz a mão atravessar a tela a cada consulta. A vizinhança com a ação principal
 * se resolve pela **vertical**, que é medida, e não pelo lado.
 *
 * **No simulado ele fica visível e indisponível** (RN-55), e não escondido:
 * recurso que some quando está indisponível é indistinguível de recurso que não
 * existe (RN-61), e sumir move de lugar o que sobra.
 *
 * O alvo tem `--alvo-conforto`, acima do mínimo de 44px da RN-56.
 */
export function MenuDoRodape({
  disponivel,
  aoAbrirAssistente,
  refDoAssistente,
}: {
  /** `false` no simulado: o alvo fica à vista e desabilitado (RN-55). */
  disponivel: boolean;
  aoAbrirAssistente: () => void;
  /** Para onde o foco volta quando o painel do assistente fecha. */
  refDoAssistente: RefObject<HTMLButtonElement | null>;
}) {
  return (
    <div className="menu-flutuante menu-flutuante--aberto" role="group" aria-label="Assistente">
      <button
        type="button"
        ref={refDoAssistente}
        className="botao-flutuante menu-flutuante__assistente"
        aria-label={
          disponivel ? "Perguntar ao assistente sobre esta questão" : "Assistente — indisponível no simulado"
        }
        title={disponivel ? "Assistente" : "O assistente fica indisponível no simulado."}
        disabled={!disponivel}
        onClick={aoAbrirAssistente}
      >
        <Icone glifo={IconeIa} papel="acao" />
      </button>
    </div>
  );
}
